import { AnalyticsProduct } from "utils/analytics/analytics.utils";
import { fromCentsWithTax } from "utils/price.utils";

import { TrackProductItemFragment } from "../track-product.query.generated";

export const fromItem = (item: TrackProductItemFragment): AnalyticsProduct => ({
  product_id: String(item.id),
  sku: item.sku,
  category: item.itemType,
  name: item.name,
  brand: item.properties.brand,
  price: fromCentsWithTax(item.sellPriceInCents, item.tax?.amount || 0),
  currency: "EUR",
});
